import { put, call, select } from 'redux-saga/effects';
import { BFFAgent } from '../../../../common/BFFAgent';
import {
    PRESUPUESTADOR_GET_PERITAJE_BEGIN,
    PRESUPUESTADOR_GET_PERITAJE_FAILURE,
    PRESUPUESTADOR_GET_PERITAJE_SUCCESS
} from '../constants';

export default function* getPeritajeSaga({ data: { patente, isCurrent, status, requestsId, isModoVer } }) {
  try {
    yield put({
      type: PRESUPUESTADOR_GET_PERITAJE_BEGIN,
      data: patente
    })
    
    let { peritaje, peritajeQuote } = yield call(BFFAgent.Peritador.getPeritaje, patente, false, isCurrent, status, requestsId);
    
    if (!peritaje) {
      const result = yield call(BFFAgent.Peritador.getPeritaje, patente, false, isCurrent);
      peritaje = result?.peritaje || null;
      peritajeQuote = result?.peritajeQuote || null;
    }
    const presupuestador = yield select(state => state.presupuestador);
    let usado = presupuestador.entregaUsados.find(auto => auto.patente === patente)
    
    if(!usado) usado = {}
    
    if (peritajeQuote) {
        let originalPrice = peritajeQuote.appraisal || usado.original_price;
        usado = {
            ...usado,
            quotation_id: peritajeQuote.requestsId,
            year: peritajeQuote.verification?.original_vehicle?.year?.label || peritajeQuote.verification.vehicle.year.label,
            brand: peritajeQuote.verification.vehicle.brand.label,
            model: peritajeQuote.verification.vehicle.model.label,
            version: peritajeQuote.verification?.original_vehicle?.version?.label || peritajeQuote.verification.vehicle.version.label,
            versionId: peritajeQuote.verification.original_vehicle?.version?.value || peritajeQuote.verification.vehicle.version.value,
            patente: peritajeQuote.verification.original_licencePlate || peritajeQuote.verification.licencePlate,
            km: peritajeQuote.verification.original_kilometraje || peritajeQuote.verification.kilometraje,
            original_price: originalPrice,
            peritado: peritajeQuote.verification.statusId,
            pending: false,
            error: null,
            appraisal: peritajeQuote.appraisal,
            verificationDate: peritajeQuote.verification.verificationDate,
            verification: peritajeQuote.verification,
            appraisal_approved: peritajeQuote.appraisal_approved,
        }
    }

    if (!peritaje) {
        yield put({
            type: PRESUPUESTADOR_GET_PERITAJE_SUCCESS,
            data: null,
            patente,
        })
    } else {
        if (usado && isModoVer) {
            yield put({
                type: PRESUPUESTADOR_GET_PERITAJE_SUCCESS,
                data: peritaje && Number(usado.peritado) !== 1 ? { peritaje, usado } : null,
                patente,
                isModoVer
            })
        } else {
            yield put({
                type: PRESUPUESTADOR_GET_PERITAJE_SUCCESS,
                data: { peritaje, usado },
                patente,
            })
        }
    }
  } catch (err) {
      yield put({
          type: PRESUPUESTADOR_GET_PERITAJE_FAILURE,
          data: { error: err },
          patente,
      })
  }
}
